import React from 'react';
import { Badge } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useUnreadNotificationCount } from '@/hooks/notifications/useUnreadNotificationCount';
import { useMarkAllAsRead } from '@/hooks/notifications/useMarkAllAsRead';

interface NotificationBadgeProps {
  onClick?: () => void;
  className?: string;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  onClick,
  className = 'text-xl cursor-pointer',
}) => {
  const { data: unreadData, isLoading, error } = useUnreadNotificationCount();
  const { mutate: markAllAsRead, isPending } = useMarkAllAsRead();
  const unreadCount = unreadData?.count || 0;

  const handleClick = () => {
    // Mark all notifications as read if there are unread notifications
    if (unreadCount > 0) {
      markAllAsRead();
    }

    // Navigate to notifications page
    if (onClick) {
      onClick();
    }
  };

  return (
    <Badge
      count={isPending ? '...' : unreadCount}
      size="small"
      offset={[-2, 2]}
      showZero={false}
      style={{
        backgroundColor: isPending ? '#1890ff' : '#ff4d4f',
        color: 'white',
        fontSize: '10px',
        fontWeight: 'bold',
        minWidth: '16px',
        height: '16px',
        lineHeight: '16px',
        borderRadius: '8px',
      }}
    >
      <BellOutlined
        className={className}
        onClick={handleClick}
        style={{
          color: isLoading || isPending ? '#d9d9d9' : undefined,
        }}
      />
    </Badge>
  );
};

export default NotificationBadge;
